<style scoped>
@media screen and (max-width: 640px){
  .el-popper[x-placement^="bottom"]{
    width: auto;
    padding: 8px;
    text-align:center ;
  }
}

@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .phone{
    margin-top: -2px;
  }
  .username{
    margin-left: 2px;
  }
}
</style>
<template>
  <div>
      <!-- 移动端 -->
      <div style="height:60px;" v-if="headFixed"></div>
      <header :class="{'head-fixed': headFixed}">
        <div class="PhoneNav">
          <!-- 移动端导航 -->
          <div style="box-sizing: border-box;padding:12px 10px ;position: relative;border-bottom: 1px solid #eee">
            <img src="@/assets/images/logo.png"  width="100px" @click="$router.push('/')">
            <div  style="float: right;color: #014492;display:flex;">
              <div class="d-flex flex-align-center pointer" @click="login" v-if="!memberInfo" style="">
                <img src="@/assets/images/icon_user.png" width="25%">请登录
              </div>
              <div class="d-flex flex-align-center pointer" v-else>
                <img src="@/assets/images/icon_user.png" width="20%" class="phone">
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link d-flex ">
                    <div class="username text-ellipsis">{{memberInfo.realName | stateFormat(memberInfo.realName)}}</div>
                    <i class="el-icon-arrow-down el-icon--right" style="margin-top: 5px;margin-left: 2px;"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item @click.native="$router.push('/user')">个人中心</el-dropdown-item>
                    <el-dropdown-item @click.native="loginOut">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="d-flex flex-align-center pointer" @click="Menu">
                <img src="@/assets/images/list.png" width="80%">
              </div>
            </div>
          </div>
          <!-- 列表 -->
          <transition name="carHistory">
            <div v-show="isShow" :style="{height:h+'px'}">
              <div class="search-box">
                <input type="text" v-model="keywords"/>
                <span class="btn-search pointer" @click="bindSearch"><img src="@/assets/images/icon_search.png"></span>
<!--                <el-badge :value="cartNums" class="item" :hidden="cartNums === 0" style="margin-left:15px">-->
<!--                  <div class="icon pointer" style="margin-right: 0;" @click="toCharts"><img src="@/assets/images/icon_chart.png" width="80%"></div>-->
<!--                </el-badge>-->
              </div>
              <el-menu
                :default-active="defaultActive"
                :router="true"
                :unique-opened="true"
                text-color="#333333"
                active-text-color="#014492"
                @select="handleSelect"
                style="overflow: auto;position: relative;"
                :style="{height:(h-55)+'px'}">
                <!--首页-->
                <component v-for="(item, index) in pageDataNew.menu"  :index="item.to" :key="index+'menu'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
                  <template slot="title">
                    <span >{{item.label}}</span>
                  </template>
                  <template v-if="item.subMenu">
                    <dl class="sub-menu" v-if="item.subMenu">
                      <dd v-for="(itx, idx) in item.subMenu" :key="idx+'menu'">
                        <div class="sub-title">{{itx.label}}</div>
                        <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'menu'" v-show="!it.disabled">{{it.label}}</el-menu-item>
                      </dd>
                    </dl>
                  </template>
                </component>
                <!--产品及服务-->
                <component v-for="(item, index) in pageDataNew.products" :index="item.to" :key="index+'products'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
                  <template slot="title">
                    <el-menu-item :index="item.to" style="display: contents">
                      <a  :href="item.to" style="color: #333333">{{item.label}}</a>
                    </el-menu-item>
                  </template>
                  <template v-if="item.subMenu">
                    <dl class="sub-menu" v-if="item.subMenu">
                      <dd v-for="(itx, idx) in item.subMenu" :key="idx+'productsOne'">
                        <div class="sub-title" style="flex:40%;">
                          <!--                    <router-link :to="`${itx.to}?name=${itx.label}`" v-if="itx.to === '/products'">{{itx.label}}</router-link>-->
                          <!--                    <router-link :to="itx.to" v-else-if="itx.to || itx.to === ''">{{itx.label}}</router-link>-->
                          <!--                    <a v-else>{{itx.label}}</a>-->

                          <el-menu-item :index="itx.to" style="display: contents">
                            <a  :href="itx.to" style="padding-left:10px;color: #333;;margin-left: -10px;position: relative;top: -5px">{{itx.label}}</a>
                          </el-menu-item>
                        </div>
                        <div style="flex:60%;color:#868788;">
                          <!--显示二级标题  -->
                          <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'productsTwo'" v-show="!it.children" class="first-title">
                            <a  :href="it.to" style="padding-left:10px;color: #333;">{{it.label}}</a>
                          </el-menu-item>
                          <!--显示三级标题  -->
<!--                          <div v-show="it.children" v-for="(it, i) in itx.children" :key="i+'productsThree'">-->
<!--                            <div>-->
<!--                                <a  :href="it.to" style="color: #333;">{{it.label}}</a>-->
<!--                            </div>-->
<!--                            <div v-if="showContent === true" v-for="(its, i) in it.children"  :key="i+'productsFour'">-->
<!--                                <a  :href="its.to" style="padding-left:10px;color: #333;">{{its.label}}</a>-->
<!--                              &lt;!&ndash;                          <a href="1" v-for="(its, i) in it.children" v-show="it.label===title" :key="i+'productsFour'" class="a" style="">{{its.label}}</a>&ndash;&gt;-->
<!--                            </div>-->
<!--                          </div>-->
                          <div v-show="it.children" v-for="(it, i) in itx.children" :key="i+'productsThree'">
                            <div @click="getClickList(it.label);showContent=!showContent">
                              <div style="font-size: 16px;padding-left: 40px; color: rgb(51, 51, 51);" class="el-menu-item first-title">
                                <a :href="it.to" style="color: rgb(51, 51, 51);">{{ it.label }}</a>
                              </div>
                            </div>
                            <div>
                              <div v-for="(its, i) in it.children" :key="i+'productsFour'"
                                   style="font-size: 14px;padding-left: 60px; color: rgb(51, 51, 51);" class="el-menu-item first-title">
                                <a :href="its.to" style="color:rgb(51, 51, 51)">{{ its.label }}</a>
                              </div>
                            </div>
                          </div>

                        </div>
                      </dd>
                    </dl>
                  </template>
                </component>
                <!--设备及原料-->
                <component v-for="(item, index) in pageDataNew.equipment"  :index="item.to" :key="index+'equipment'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
                  <template slot="title">
                    <!--              <span >{{item.label}}</span>-->
                    <el-menu-item :index="item.to" style="display: contents;">
                      <a  :href="item.to" style="color: #333333">{{item.label}}</a>
                    </el-menu-item>
                  </template>
                  <template v-if="item.subMenu">
                    <dl class="sub-menu sub-menu1" v-if="item.subMenu" style="flex-direction: row;flex-wrap: nowrap;">
                      <dd v-for="(itx, idx) in item.subMenu" :key="idx+'equipmentOne'">
                        <div class="sub-title" >
                          <!--                    {{itx.label}}-->
                          <el-menu-item :index="itx.to" style="display: contents;">
                            <a  :href="itx.to" style="padding-left:10px;color: #333;;margin-left: -10px;position: relative;top: -5px">{{itx.label}}</a>
                          </el-menu-item>
                        </div>
                        <div style="color:#868788;">
                          <!--显示二级标题  -->
                          <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'equipmentTwo'" v-show="!it.children" class="first-title">
                            <a  :href="it.to" style="padding-left:10px;color: #333" v-if="!it.ref">{{it.label}}</a>
                            <a  v-else-if="it.ref" :href="it.ref" style="margin-left: 10px;color: #333">{{it.label}}</a>
                          </el-menu-item>
                          <!--显示三级标题  -->
<!--                          <div v-for="(it, i) in itx.children" :key="i+'equipmentThree'">-->
<!--                            <div>-->
<!--                              &lt;!&ndash;                          {{it.label}}&ndash;&gt;-->
<!--                              <el-menu-item :index="it.to" >-->
<!--                                <a  :href="it.to" style="color: #333;">{{it.label}}</a>-->
<!--                              </el-menu-item>-->
<!--                            </div>-->
<!--                            <div v-if="showContent">-->
<!--                              <el-menu-item :index="its.to" v-for="(its, i) in it.children"  :key="i+'equipmentFour'"  style="" class="a first-title">-->
<!--                                &lt;!&ndash;                            <span slot="title" style="padding-left:10px">{{its.label}}</span>&ndash;&gt;-->
<!--                                <a  :href="its.to" style="padding-left:10px;color: #333;" v-if="!its.ref">{{its.label}}</a>-->
<!--                                <a  v-else-if="its.ref" :href="its.ref" style="margin-left: 10px;color: #333;">{{its.label}}</a>-->
<!--                              </el-menu-item>-->
<!--                              &lt;!&ndash;                          <a href="" v-for="(its, i) in it.children" v-show="it.label===title" :key="i+'equipmentFour'" class="a" style="">{{its.label}}</a>&ndash;&gt;-->
<!--                            </div>-->
<!--                          </div>-->
                          <div v-show="it.children" v-for="(it, i) in itx.children" :key="i+'equipmentThree'">
                            <div @click="getClickList(it.label);showContent=!showContent">
                              <div style="font-size: 16px;padding-left: 40px; color: rgb(51, 51, 51);" class="el-menu-item first-title">
                                <a :href="it.to" style="color: rgb(51, 51, 51);">{{ it.label }}</a>
                              </div>
                            </div>
                            <div>
                              <div v-for="(its, i) in it.children" :key="i+'equipmentFour'"
                                   style="font-size: 14px;padding-left: 60px; color: rgb(51, 51, 51);" class="el-menu-item first-title">
                                <a :href="its.to" style="color:rgb(51, 51, 51)">{{ its.label }}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </dd>
                    </dl>
                  </template>
                </component>
                <component v-for="(item, index) in pageDataNew.biology"  :index="item.to" :key="index+'biology'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
                  <template slot="title">
                    <span >{{item.label}}</span>
                  </template>
                  <template v-if="item.subMenu">
                    <dl class="sub-menu" v-if="item.subMenu">
                      <dd v-for="(itx, idx) in item.subMenu" :key="idx+'biologyOne'">
                        <div class="sub-title">{{itx.label}}</div>
                        <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'biologyTwo'" v-show="!it.disabled">{{it.label}}</el-menu-item>
                      </dd>
                    </dl>
                  </template>
                </component>
                <!-- 基因工厂 -->
                <component v-for="(item, index) in pageDataNew.geneFactory"  :index="item.to" :key="index+'geneFactory'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
                  <template slot="title">
                    <span >{{item.label}}</span>
                  </template>
                  <template v-if="item.subMenu">
                    <dl class="sub-menu" v-if="item.subMenu">
                      <dd v-for="(itx, idx) in item.subMenu" :key="idx+'geneFactoryOne'">
                        <div class="sub-title">{{itx.label}}</div>
                        <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'geneFactoryTwo'" v-show="!it.disabled">{{it.label}}</el-menu-item>
                      </dd>
                    </dl>
                  </template>
                </component>
                <!--资源中心-->
                <component v-for="(item, index) in pageDataNew.resource"  :index="item.to" :key="index+'resource'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
                  <template slot="title">
                    <span >{{item.label}}</span>
                  </template>
                  <template v-if="item.subMenu">
                    <dl class="sub-menu" v-if="item.subMenu" style="flex-direction: row;flex-wrap: nowrap;">
                      <dd v-for="(itx, idx) in item.subMenu" :key="idx+'resourceOne'">
                        <div class="sub-title">{{itx.label}}</div>
                        <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'resourceTwo'" v-show="!it.disabled">{{it.label}}</el-menu-item>
                      </dd>
                    </dl>
                  </template>
                </component>
                <!--擎科概况-->
                <component v-for="(item, index) in pageDataNew.summary"  :index="item.to" :key="index+'summary'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
                  <template slot="title">
                    <span >{{item.label}}</span>
                  </template>
                  <template v-if="item.subMenu">
                    <dl class="sub-menu" v-if="item.subMenu" style="flex-direction: row;flex-wrap: nowrap;">
                      <dd v-for="(itx, idx) in item.subMenu" :key="idx+'summaryOne'">
                        <div class="sub-title" style="flex:40%;">{{itx.label}}</div>
                        <div style="flex:60%;color:#868788;">
                          <!--显示二级标题  -->
                          <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'summaryTwo'" v-show="!it.children" class="first-title">
                            <a  :href="it.to" style="padding-left:10px;color: #333;">{{it.label}}</a>
                          </el-menu-item>
                          <!--显示三级标题  -->
                          <div v-show="it.children" v-for="(it, i) in itx.children" :key="i+'summaryThree'">
                            <div class="second-title" @click="getClickList(it.label);showContent=!showContent" >

                              {{it.label}}
                            </div>
                            <div v-if="it.label===title && showContent === true">
                              <a href="" v-for="(its, i) in it.children" :key="i+'summaryFour'" class="a" style="">{{its.label}}</a>
                            </div>
                          </div>
                        </div>
                      </dd>
                    </dl>
                  </template>
                </component>
                <!--商城-->
                <component v-for="(item, index) in pageDataNew.kbb"  :index="item.to" :key="index+'kbb'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
                  <template slot="title">
                    <el-menu-item :index="item.ref" style="display: contents;">
                      <a  :href="item.ref" style="color: #333333">{{item.label}}</a>
                    </el-menu-item>
                  </template>
                </component>
<!--                <component v-for="(item, index) in pageData.menu" :index="item.to" :key="index" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">-->
<!--                  <template slot="title">-->
<!--                    <span>{{item.name}}</span>-->
<!--                  </template>-->
<!--                  <template v-if="item.subMenu">-->
<!--                    <dl class="sub-menu" v-if="item.subMenu">-->
<!--                      <dd v-for="(itx, idx) in item.subMenu" :key="idx">-->
<!--                        <div class="sub-title">{{itx.name}}</div>-->
<!--                        <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i" v-show="!it.disabled">{{it.name}}</el-menu-item>-->
<!--                      </dd>-->
<!--                    </dl>-->
<!--                  </template>-->
<!--                </component>-->

              </el-menu>
            </div>
          </transition>
        </div>
      </header>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { carts, newsColumns, productCategories } from '@/services/api.index'
export default {
  name: 'qk-header-phone',
  data() {
    return {
      activeIndex: '1',
      isShow:false,
      showList: false,
      isDown:false,
      isRight: true,
      memberInfo: this.baseMethods.getLocalObj('memberInfo'),
      cartNums: 0,
      keywords: '',
      headFixed: false,
      showMask: false,
      h:''
    };
  },
  watch: {
    $route (to, from) {
      // if(to.path === '/user') {
      //   this.memberInfo = this.baseMethods.getLocalObj('memberInfo')
      // }
      this.memberInfo = this.baseMethods.getLocalObj('memberInfo')
    }
  },
  created() {
    const outPaths = ['/register', '/account_status', '/reset', '/', '/qq_conn/101972422', '/app/', '/app/apple-app-site-association', '/qq_conn/101972422/apple-app-site-association']
    const path = this.$route.path
    // if ((!outPaths.includes(path) && path.indexOf('/products/details') < 0) || ((path === '/' || path.indexOf('/products/details') > -1) && this.baseMethods.getLocalObj('userInfo'))) {
    //   this.getCartInfo()
    // }
    if (!outPaths.includes(path) && this.baseMethods.getLocalObj('userInfo')) {
      this.getCartInfo()
    }
    this.getNewsTabs()
    this.getCategories()
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        this.memberInfo = this.baseMethods.getLocalObj('memberInfo')
      }
    });
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
    this.h = document.documentElement.clientHeight - 55
  },
  computed: {
    ...mapState(['pageDataNew']),
    defaultActive () {
      return decodeURIComponent(this.$route.fullPath)
    }
  },
  filters: {
    stateFormat(stateId) {
      if(stateId){
        return stateId.substring(0,3)
      }
    }
  },
  methods: {
    scrollToTop () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.headFixed = scrollTop > 60
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.isShow = false
    },
    getCartInfo () {
      console.log("所以说这边的缓存是有的-----",this.baseMethods.getLocalObj('userInfo'))
      carts().then(res => {
        res.data.map(item => {
          this.cartNums += item.quantity
        })
      })
    },
    Menu() {
      this.isShow = !this.isShow
    },
    // 购物车
    toCharts () {
      this.$router.push('/products/chart')
      this.isShow = false
    },
    // 获取新闻栏目
    async getNewsTabs () {
      if (this.pageDataNew.summary[0].subMenu[1].children.length > 0) return
      let newsMenu = []
      await newsColumns().then(res => {
        res.data.map((item, index) => {
          newsMenu.push({name: item.name, to: `/news?id=${item.id}&current=${index}`})
        })
      })
      this.pageDataNew.summary.map(item => {
        if (item.name === '擎科概况') {
          item.subMenu.map(itx => {
            if (itx.name === '新闻') {
              // itx.children = []
              itx.children = itx.children.concat(newsMenu)
            }
          })
        }
      })
    },
    // 获取产品栏目
    async getCategories () {
      // if (this.pageData.menu[2].subMenu) return
      let categories = []
      let childrenLists = []
      await productCategories().then(res => {
        res.data.map(item => {
          if (item.canShow) {
            if (item.level === 1) {
              categories.push(item)
            } else {
              childrenLists.push(item)
            }
          }
        })
        categories.map(item => {
          item.children = []
          childrenLists.map(itx => {
            if (itx.level === 2 && itx.parent.id === item.id) {
              itx.to = `/products?name=${itx.name}&id=${itx.id}`
              item.children.push(itx)
            }
          })
          if (item.children.length === 0) {
            item.to = `/products?name=${item.name}&id=${item.id}`
            item.children.push(item)
          }
        })
        console.log(categories)
        // this.categories = categories
      })
      this.pageDataNew.menu.map(item => {
        if (item.name === '擎科产品') {
          item.subMenu = []
          item.subMenu = item.subMenu.concat(categories)
        }
      })
    },
    login(){
      // window.location.replace('http://www.dev.masterbio.shop/member/login')
      window.location =(process.env.SHOP_URL + "member/login?redirectUrlTs="+ this.$route.fullPath)
    },
    // 退出登录
    loginOut () {
      localStorage.clear()
      this.$router.push('/')
      // window.location.replace('http://dev.masterbio.shop/')
    },
    // 搜索
    bindSearch () {
      this.isShow = false
      this.$router.push(`/search?keywords=${this.keywords}`)
    },
    getClickList (label) {
      this.title = label
    }
  }
}
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
}

 @media screen and (min-width: 1200px){
  .PhoneNav {
      display:none;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px){
  .PhoneNav {
      display: none;
  }
}
@media screen and (max-width: 768px){
  .head-fixed{
    position: fixed;
    top:0;
    left:0;
    width:100%;
    z-index: 99;
    background: #fff;
  }
  .PhoneNav {
    display: block;
    width: 100%;
    /* position: fixed; */
    /* top:0; */
    z-index:22000;
    background: #fff;
  }
  .search-box{
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    width: 100%;
    margin:0 auto;
    padding: 10px;
  }
  input{
    background: #F9F9F9;
    height:30px;
    line-height: 30px;
    padding-right:20px;
    border-radius: 4px 0 0 4px;
    border:1px solid #ddd;
    border-right: 0;
    width: 70%;
  }
  .btn-search{
    height:30px;
    background: #014492;
    img{
      height: 30px;
    }
  }
}
.carHistory-enter {
  animation: carHistory-dialog-fade-in 0.3s ease;
}
.carHistory-leave {
  animation: carHistory-dialog-fade-out 0.3s ease forwards;
}
.carHistory-enter-active {
  animation: carHistory-dialog-fade-in 0.3s ease;
}
.carHistory-leave-active {
  animation: carHistory-dialog-fade-out 0.3s ease forwards;
}

.el-menu--horizontal{
    left:0 !important;
    right:0;
    margin-top: 1px;
    background: #fff;
    .el-menu--popup{
      width:1000px;
      margin:20px auto 0;
      box-shadow: none;
    }
    .el-submenu .el-submenu__icon-arrow{
      display: none;
    }
  }
  .head-fixed{
    .el-menu--horizontal{
      top:auto !important;
    }
  }
  .el-menu.el-menu--horizontal{
    border-bottom:0;
  }
  .el-menu-item {
    font-size: 16px !important;
  }
  .el-menu >>> .el-submenu__title{
    font-size: 16px !important;
  }
  .el-menu--horizontal>.el-menu-item{
    text-align: center;
    width:100%;
    margin-right: 10px;
    border-bottom: 1px solid #ddd !important;
    &:hover{
      color:#014492 !important;
      font-weight: bold;
    }
  }
  .el-menu--horizontal>.el-menu-item.is-active{
    // border-bottom: 4px solid #014492;
    font-weight: bold;
    background: #EFF5FF !important;
  }
  .el-menu--horizontal .el-menu .el-menu-item.is-active{
    font-weight: bold;
  }
  .sub-menu{
    display: block!important;
    flex-wrap: wrap;
    height: auto;
    min-height: 480px;
    dd{
      display: block!important;
      width:150px;
      margin-right: 100px;
      margin-bottom: 0!important;
    }
    .sub-title{
      font-weight: bold;
      font-size: 14px;
      // text-align: center;
      padding: 10px 0;
      padding-left: 30px;
      border-bottom: 1px solid #eee;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
.sub-title:before {
  color: #fff;
  font-size: 25px;
  content:' · ';
  font-weight: bold;
}
  .el-menu--horizontal .el-menu .el-menu-item{
    padding:0;
    &:hover{
      color:#014492 !important;
      font-weight: bold;
    }
  }
  .username{
    max-width:60px;
    min-width: 0;
    flex:1;
  }
  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    color:#014492;
    font-weight: bold;
    border-bottom: 4px solid #014492;
    background: #EFF5FF !important;
  }
  .el-menu--horizontal>.el-submenu.is-opened .el-submenu__title{
    color:#014492 !important;
    font-weight: bold;
  }
  .popper__arrow{
    margin-left: -12px;
  }
  .dropdown-menu{
    box-shadow: 0 5px 8px rgba(0,0,0,.1);
  }
  .el-submenu >>>.el-menu-item {
    font-size: 16px;
    margin-left: 30px;
    // height: 40px;
    // line-height: 40px;
  }
  .el-dropdown-menu .el-popper {
    top: 50px !important;
    position: absolute;
    left: 160px;
    transform-origin: center top;
    z-index: 2001;
  }

@keyframes carHistory-dialog-fade-in {
  0% {
    transform: translate3d(-100%, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes carHistory-dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(-100%, 0, 0);
    opacity: 1;
  }
}
/* .el-icon-arrow-down {
  display: none;
} */

</style>



// WEBPACK FOOTER //
// src/components/headerPhone.vue